// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(true);
// Module
exports.push([module.id, ".dropdown-menu-custom {\n  max-height: 200px;\n  overflow: auto;\n}", "",{"version":3,"sources":["/home/talent/Documents/BizPort/hse/app/javascript/packs/App/components/table/style.scss","style.scss"],"names":[],"mappings":"AAAA;EACE,iBAAA;EACA,cAAA;ACCF","file":"style.scss","sourcesContent":[".dropdown-menu-custom {\n  max-height: 200px;\n  overflow: auto;\n}",".dropdown-menu-custom {\n  max-height: 200px;\n  overflow: auto;\n}"]}]);
// Exports
module.exports = exports;
